export default class Block {
	constructor(element, eventEmitter) {
		this.element = element
		this.eventEmitter = eventEmitter
	}

	getElement(name) {
		return this.element.querySelector(`.${this.constructor.title}__${name}`)
	}

	getElements(name) {
		return this.element.querySelectorAll(`.${this.constructor.title}__${name}`)
	}

	addElementModifier(name, modifier) {
		this.getElement(name).classList.add(
			`${this.constructor.title}__${name}--${modifier}`
		)
	}

	removeElementModifier(name, modifier) {
		this.getElement(name).classList.remove(
			`${this.constructor.title}__${name}--${modifier}`
		)
	}

	toggleElementModifier(name, modifier) {
		this.getElement(name).classList.toggle(
			`${this.constructor.title}__${name}--${modifier}`
		)
	}

	hasElementModifier(name, modifier) {
		return this.getElement(name).classList.contains(
			`${this.constructor.title}__${name}--${modifier}`
		)
	}

	addModifier(modifier) {
		this.element.classList.add(`${this.constructor.title}--${modifier}`)
	}

	removeModifier(modifier) {
		this.element.classList.remove(`${this.constructor.title}--${modifier}`)
	}

	toggleModifier(modifier) {
		this.element.classList.toggle(`${this.constructor.title}--${modifier}`)
	}

	hasModifier(modifier) {
		return this.element.classList.contains(
			`${this.constructor.title}--${modifier}`
		)
	}

	isValidBlock(element) {
		if (element === null) {
			return false
		}

		return typeof element.ref !== 'undefined'
	}

	handleError(error) {
		if (process.env.NODE_ENV === 'development') {
			console.error(error)
		}

		this.eventEmitter.emit('message:send', error.toString())
	}
}
